/**
 * Models the result of signing multisig tx hex.
 */
export default class MoneroMultisigSignResult {
    constructor(result) {
        Object.assign(this, result);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getSignedMultisigTxHex() {
        return this.signedMultisigTxHex;
    }
    setSignedMultisigTxHex(signedTxMultisigHex) {
        this.signedMultisigTxHex = signedTxMultisigHex;
        return this;
    }
    getTxHashes() {
        return this.txHashes;
    }
    setTxHashes(txHashes) {
        this.txHashes = txHashes;
        return this;
    }
}
